<template>
  <v-layout column>
    <v-layout column>
      <v-toolbar extended dense
                 class="load-toolbar"
                 extension-height="100" flat >
        <v-btn-toggle mandatory
                      v-model="viewToggle">
          <v-btn value="text">
            <span>Text Message</span>
            <v-icon>textsms</v-icon>
          </v-btn>
          <v-btn  value="file">
            <span>Upload File</span>
            <v-icon>attach_file</v-icon>
          </v-btn>
        </v-btn-toggle>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn flat @click="reloadConversation">
            <v-layout column>
              <v-icon>refresh</v-icon>
              Reload
            </v-layout>
          </v-btn>
        </v-toolbar-items>

        <template slot="extension">
          <template v-if="viewToggle === 'text'">
            <v-flex sm10 xs8>
              <v-textarea block v-model="messageText"
                          :rows="2"
                          label="Type something...">
              </v-textarea>
            </v-flex>
            <v-spacer />
            <v-flex sm2 xs4>
              <v-btn block class="mr-0 px-0"
                     :loading="loadingData" :disabled="loadingData"
                     @click="sendMessage">
                Send
              </v-btn>
            </v-flex>
          </template>
          <template v-else>
            <v-flex sm9 xs8>
              <v-textarea block v-model="messageText"
                          :rows="2"
                          label="Type something then select image...">
              </v-textarea>
              <input type="file"
                     :ref="'settlementAttach_'+itemId" hidden
                     @change="processSettlementAttachment($event)"/>
            </v-flex>
            <v-spacer />
            <v-flex sm3 xs4>
              <v-btn class="primary ml-0"
                     :loading="loadingData"
                     @click="openFileSelector('settlementAttach_'+itemId)"
                     :disabled="_.isEmpty(messageText) || loadingData">
                Select File
              </v-btn>
            </v-flex>
          </template>
        </template>
      </v-toolbar>
    </v-layout>
    <slot name="conversationBanner">

    </slot>
    <div class="timeline-section mt-2"
         style="height: 380px;"
         :class="[{'text-md-center text-lg-center text-sm-center pt-4': loadingData}]">
      <timeline v-if="timeline && !loadingData"
                :timeline-object="timeline"></timeline>
      <v-progress-circular v-if="loadingData"
                           indeterminate color="primary">
      </v-progress-circular>
    </div>
  </v-layout>
</template>

<script>
import _ from 'lodash';

import * as types from '@/store/mutationTypes';
import API from '@/api';

import Timeline from '@/components/timeline/Timeline';

export default {
  name: 'VLoadConversation',
  props: {
    bidId: {
      type: String,
      default: null,
    },
    loadId: {
      type: String,
      default: null,
    },
    txnId: {
      type: String,
      default: null,
    },
    maxHeight: {
      type: String,
      required: true,
    },
    disableForm: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  components: {
    Timeline,
  },
  data: () => ({
    loadingData: false,
    timeline: null,
    messageText: null,
    viewToggle: 'text',
  }),
  computed: {
    _() {
      return _;
    },
    itemId() {
      return this.bidId || this.txnId || this.loadId;
    },
  },
  watch: {
    bidId() {
      this.reloadConversation();
    },
    txnId() {
      this.reloadConversation();
    },
    loadId() {
      this.reloadConversation();
    },
  },
  methods: {
    async reloadConversation() {
      let loadPromise;
      if (this.bidId) {
        loadPromise = API.bid.getConversation({ bidId: this.bidId });
      }
      if (this.txnId) {
        loadPromise = API.settlements.getTimeline(this.txnId);
      }
      if (this.loadId) {
        loadPromise = API.load.getFulfillment({ loadId: this.loadId });
      }

      this.loadingData = true;
      try {
        const response = await loadPromise;
        this.timeline = response.data;
      } catch (err) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: 'An error occurred, please try again later. ' + error.message,
        });
      } finally {
        this.loadingData = false;
      }
    },
    async sendMessage() {
      let updatePromise;
      const messageRequest = {
        message: this.messageText,
        sent: new Date().toISOString(),
      };

      if (this.bidId) {
        updatePromise = API.bid.updateBidTimeline({
          bidId: this.bidId,
          messageRequest,
        });
      }
      if (this.txnId) {
        updatePromise = API.settlements.sendMessage({
          settlementId: this.txnId,
          messageRequest,
        });
      }
      if (this.loadId) {
        updatePromise = API.load.updateFulfillment({
          loadId: this.loadId,
          messageRequest,
        });
      }

      try {
        this.loadingData = true;
        await updatePromise;
        this.messageText = '';
        this.reloadConversation();
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: 'An error occurred, please try again later. ' + error.message,
        });
      } finally {
        this.loadingData = false;
      }
    },
    async processSettlementAttachment(event) {
      let attachPromise;
      const getBase64ApiCalls = [];
      for (let i = 0; i < event.target.files.length; i++) {
        getBase64ApiCalls.push(await this.getBase64(event.target.files[i]));
      }

      const photoBase64s = await Promise.all([
        getBase64ApiCalls,
      ]);

      if (this.bidId) {
        attachPromise = API.bid.uploadBidPhoto({
          photoBase64s,
          name: this.messageText,
          bidId: this.bidId,
        });
      }
      if (this.txnId) {
        attachPromise = API.settlements.uploadSettlementFile({
          settlementId: this.txnId,
          base64s: photoBase64s,
          message: this.settlementText,
        });
      }
      if (this.loadId) {
        attachPromise = API.load.uploadFulfillmentPhoto({
          photoBase64s,
          name: this.messageText,
          loadId: this.loadId,
        });
      }

      try {
        this.$store.commit(`applications/${types.START_LOADING}`);

        await attachPromise;
        this.messageText = '';
        this.reloadConversation();
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },

    openFileSelector(refId) {
      this.$refs[refId].click();
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

  },
  created() {
    if (this.itemId) {
      this.reloadConversation();
    } else {
      throw new TypeError('Must provide one of the following attributes: load-id, txn-id, or bid-id');
    }
  },
};
</script>

<style scoped>
  .timeline-section {
    overflow-y: auto;
  }
</style>

<style>
  .load-toolbar .v-toolbar__content,
  .load-toolbar .v-toolbar__extension {
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoadConversation.vue